var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpenBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.3330078125,
    height: 11,
    viewBox: "0 0 18.3330078125 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 0.916674C5.68335 0.916674 3.025 2.38333 1.09999 5.5C3.025 8.61667 5.68335 10.0833 9.16667 10.0833C12.65 10.0833 15.3083 8.61667 17.2334 5.5C15.3083 2.38333 12.65 0.916674 9.16667 0.916674ZM9.16667 11C5.225 11 2.10834 9.16667 0 5.5C2.10834 1.83333 5.225 0 9.16667 0C13.1083 0 16.225 1.83333 18.3333 5.5C16.225 9.16667 13.1083 11 9.16667 11ZM9.16667 7.33333C10.175 7.33333 11 6.50833 11 5.5C11 4.49167 10.175 3.66667 9.16667 3.66667C8.15835 3.66667 7.33335 4.49167 7.33335 5.5C7.33335 6.50833 8.15835 7.33333 9.16667 7.33333ZM9.16667 8.25C7.60835 8.25 6.41667 7.05833 6.41667 5.5C6.41667 3.94167 7.60835 2.75 9.16667 2.75C10.725 2.75 11.9167 3.94167 11.9167 5.5C11.9167 7.05833 10.725 8.25 9.16667 8.25Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenBtn);
export default __webpack_public_path__ + "static/media/eye_open_btn.92600872d7795f128c14a3a5bb609934.svg";
export { ForwardRef as ReactComponent };